import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface StepProps {
  formData: {
    branchDescription: string;
    branchDescriptionAR: string;
  };
  onInputChange: (field: string, value: string) => void;
}

const toolbarOptions = [
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['link'],
  ['clean'],
];

const Step5BranchDescriptions: React.FC<StepProps> = ({ formData, onInputChange }) => {
  return (
    <div className="space-y-8">
      <h3 className="text-xl font-semibold text-gray-800">
        Branch-Specific Descriptions
      </h3>

      {/* English */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          English description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.branchDescription}
          onChange={(val) => onInputChange('branchDescription', val)}
          modules={{ toolbar: toolbarOptions }}
          className="bg-white"
        />
      </div>

      {/* Arabic */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          الوصف العربي
        </label>
        <ReactQuill
          theme="snow"
          value={formData.branchDescriptionAR}
          onChange={(val) => onInputChange('branchDescriptionAR', val)}
          modules={{ toolbar: toolbarOptions }}
          className="bg-white"
        />
      </div>
    </div>
  );
};

export default Step5BranchDescriptions;
